@use "~theme/typography";
@use "~theme/breakpoints";

$round-bottom: 0 0 4px 4px;
$availability-padding: 8px;
$doctor-spacing: 4px;

.doctor {
  min-width: 212px;
  font-size: 100%; // Reset <button> styles
  border: none; // Reset <button> styles
  margin: 8px $doctor-spacing 0;
  padding: 16px 4px 4px;
  cursor: pointer;
  position: relative;
  display: table;
  scroll-snap-align: start;
  align-items: center;
  text-align: center;
  max-width: 224px;
}

.indicator {
  position: absolute;
  top: -8px;
  left: 0;
  right: 0;
  height: 4px;
  width: 100%;
  border-radius: $round-bottom;
  background-color: var(--gray-03);
  z-index: var(--float);
}

.avatar {
  display: inline-block;
  border-radius: 50%;
  box-shadow: 0 0 0 2px var(--gray-02); // Outer Ring
  border: 2px solid var(--transparent); // Inner Ring
  filter: grayscale(30%) opacity(70%);
}

.availability {
  @include typography.caption;
  border-radius: $round-bottom;
  padding: 8px;
  text-align: center;
  color: var(--blue-01);
  white-space: normal;
}

.name {
  margin: 12px 12px 4px;
  white-space: nowrap;
  font-weight: var(--semibold-weight);
  color: var(--black);
}

.profile {
  text-align: center;
}

.selected {
  background-color: var(--blue-03-at-30);

  .indicator {
    background-color: var(--blue-01);
  }

  .avatar {
    box-shadow: 0 0 0 2px var(--blue-01); // Outer ring
    filter: none;
  }

  .availability {
    background-color: var(--blue-01);
    color: var(--white);
  }

  a {
    color: var(--white);
  }
}

.doctor:not(:last-child)::after {
  content: "";
  position: absolute;
  top: $availability-padding;
  bottom: $availability-padding;
  right: -1 * ($doctor-spacing + 0.5px); // 0.5px compensates for width of line itself.
  width: 1px;
  background-color: var(--gray-03);
}

.doctor:first-child .indicator {
  border-radius: $round-bottom;
}

.doctor:last-child .indicator {
  border-radius: $round-bottom;
}

.doctor:not(.selected):hover {
  background-color: var(--blue-03-at-30);

  .avatar {
    box-shadow: 0 0 0 2px var(--blue-01-at-30); // Outer ring
    filter: grayscale(30%) opacity(80%);
  }
}

.teleopt {
  @include typography.caption;
}


  
.doctorName {
    font-weight: 400;
    font-size: 16px;
    color: var(--black);
}

.doctorAddress {
    font-weight: 400;
    font-size: 12px;
    color: var(--blue-01);
}

.retiring {
  font-size: 10px;
  background: var(--blue-01);
  border-radius: 4px;
  color: white;
  width: 83px;
  height: 20px;
  padding: 0px 2px;
  margin-top: 5px;
}
